module.exports = __webpack_public_path__ + "img/joel-headshot2@2x.7d1f8ed2.png";